import React from "react"
import { Box } from "@mui/material"
import { AppAntSwitch } from "@components"
import { AppCategoriesAutocomplete } from "@components/Autocomplete"
import useAutoEuropeDataInfo from "Pages/AutoEuropeTool/Page/@hooks/useDataInfo"
import { autoEuropeDrawerData } from "Pages/AutoEuropeTool/Page/@signals"

export default function AutoEuropeFilterCategories() {
	const { dataInfo, setDataInfo } = useAutoEuropeDataInfo(autoEuropeDrawerData.peek().filterCategories ?? [])
	const { dataInfo: exclInfo, setDataInfo: setExcl } = useAutoEuropeDataInfo(autoEuropeDrawerData.peek().filterCategoriesExclusion ?? false)

	const isExclusion = exclInfo.value

	return (
		<Box>
			<AppAntSwitch
				falseText="Include categories"
				trueText="Exclude categories"
				falseIcon="circle-check"
				trueIcon="ban"
				checked={isExclusion}
				onChange={e => setExcl(e.target.checked, 'filterCategoriesExclusion')}
				chipSx={{ mb: 1.5 }}
			/>
			<AppCategoriesAutocomplete
				label={isExclusion ? 'Exclude Categories' : 'Include Categories'}
				placeholder={isExclusion ? 'No categories excluded' : 'No categories included'}
				value={dataInfo.value ?? []}
				onChange={e => setDataInfo(e.target.value, 'filterCategories')}
			/>
		</Box>
	)
}